<template>
    <div class="card mb-25 border-0 bg-white add-user-card">
        <div class="card-header">
            <h3 class="text-black fw-semibold">Enregistrement du bon</h3>
        </div>
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
            <Form  @submit="addBon" :keep-values="valuess" :validation-schema="bonSchema">
                <div class="row">
                    <div class="col-md-12">
                        <div class="row">
                            <div class="col-md-10">
                                <div class="row">
                                    <div class="col-md-6 mb-2">
                                        <div class="form-group">
                                            <label class="d-block text-black fw-semibold mb-10">
                                                Date Opération <span class="text-danger">*</span>
                                            </label>
                                            <Field name="dateOperation" v-model="dateOperation" type="datetime-local" :max="currentDateTime"
                                                class="form-control shadow-none fs-md-15 text-black"
                                                placeholder="Date oper." />
                                            <ErrorMessage name="dateOperation" class="text-danger" />
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-2">
                                        <div class="form-group ">
                                            <label class="d-block text-black fw-semibold mb-10">
                                                Référence du document <span class="text-danger">*</span>
                                            </label>
                                            <Field name="refDoc" v-model="refDoc" type="text"
                                                class="form-control shadow-none fs-md-15 text-black"
                                                placeholder="Reférence" />
                                            <ErrorMessage name="refDoc" class="text-danger" />
                                        </div>
                                    </div>
                                    <!--<div class="col-md-4 mb-2">
                                        <div class="form-group ">
                                            <label class="d-block text-black fw-semibold mb-10">
                                                Type opération <span class="text-danger">*</span>
                                            </label>
                                            <Field name="typeOperation" v-model="typeOperation" v-slot="{ field }">
                                                <Multiselect v-model="field.value"  v-bind="field" :searchable="true"
                                                    :options="lestypes" placeholder="Choisir" />
                                            </Field>
                                            <ErrorMessage name="typeOperation" class="text-danger" />

                                        </div>
                                    </div>
                                    <div class="col-md-4 mb-2">
                                        <label class="d-block text-black fw-semibold mb-10">
                                            Motif de l'Opération <span class="text-danger">*</span>
                                        </label>
                                        <div class="form-group ">
                                            <Field name="motifSuivi" v-model="motifSuivi" v-slot="{ field }">
                                                <Multiselect v-model="field.value" :options="motifSuiviOptions"
                                                    :searchable="true"  v-bind="field" placeholder="Choisir" />
                                            </Field>
                                            <ErrorMessage name="motifSuivi" class="text-danger" />
                                        </div>
                                    </div>-->
                                    <div class="col-md-12 mb-2">
                                        <div class="form-group ">
                                            <label class="d-block text-black fw-semibold mb-10">
                                                Client <span class="text-danger">*</span>
                                            </label>
                                            <Field name="client" v-slot="{ field }">
                                                <Multiselect :close-on-select="true" :options="clientOptions"
                                                    :searchable="true"  v-bind="field" v-model="field.value" :multiple="false"
                                                    placeholder="Sélectionner le client" />
                                            </Field>
                                            <ErrorMessage name="client" class="text-danger" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <label class="d-block text-black fw-semibold mb-1">
                                    Image du bon
                                </label>
                                <div class="upload-container">
                                    <input type="file" ref="fileInput" @change="(event) => onFilePrinChange(event)"
                                        accept="image/jpeg, image/png, image/jpg" hidden />
                                    <!-- Carte d'aperçu (cliquable pour choisir une image) -->
                                    <div class="preview-card" @click="triggerFileInput">
                                        <img v-if="imagePreview" :src="imagePreview" alt="Image preview" />
                                        <div v-else class="text-center">
                                            <div> <i class="icofont icofont-camera fs-1"></i></div>
                                            Cliquez pour ajouter l'image du bon
                                        </div>
                                        <!-- Bouton de suppression sur l'image -->
                                        <button v-if="imagePreview" class="delete-btn" @click.stop="removeImage"><i
                                                class="icofont icofont-close"></i></button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="col-md-12 m-10">
                        <div class="row">
                            <div class="border border-primary mb-10">
                                <div
                                    class="row d-flex align-items-center justify-content-between fw-bold py-2 bg-primary">
                                    <div class="col-md-7">
                                        <h4 class="fs-4 text-white">Les produits</h4>
                                    </div>
                                    <div class="col-md-5">
                                        <div class="d-flex float-end">
                                            <button class="btn btn-success" type="button" :disabled="isDisable"
                                                :class="{ 'cursor-not-allowed': isDisable }" @click="addRowProduit()">
                                                <i class="fa fa-plus-circle position-relative me-1 fs-12"></i>Ajouter un
                                                produit
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div class="row gx-2" v-for="(produit, produitIndex) in produits"
                                        :key="produitIndex">
                                        <div class="col-md-6 mb-2">
                                            <div class="form-group mb-15 mb-sm-20 mb-md-25">
                                                <label v-if="produitIndex == 0" class="d-block text-black fw-semibold">
                                                    Produit
                                                </label>
                                                <Multiselect v-model="produit.produit" :options="produitOptions"
                                                    :searchable="true" placeholder="Sélectionner un produit"
                                                    @select="selectProd(produit.produit, produit)" :class="validateRowProduit(produit.produit)
                                                        ? 'fs-md-15 text-black is-invalid '
                                                        : ' fs-md-15 text-black '" />
                                                <div class="text-danger" v-if="validateRowProduit(produit.produit)">
                                                    Le produit est obligatoire.
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-3 mb-2">
                                            <div class="form-group">
                                                <label v-if="produitIndex == 0" class="d-block text-black fw-semibold">
                                                    Quantité Bon
                                                    <span class="text-danger">*</span>
                                                </label>
                                                <div class="input-group">
                                                    <input type="number" v-model="produit.qteBon" :class="validateRowProduit(produit.qteBon)
                                                        ? 'form-control shadow-none fs-md-15 text-black is-invalid '
                                                        : 'form-control shadow-none fs-md-15 text-black '"
                                                        placeholder="Entrer la quantité"
                                                        aria-label="Sizing example input"
                                                        aria-describedby="inputGroup-sizing-sm" />
                                                    <span class="input-group-text" id="inputGroup-sizing-default">{{
                                                        produit.uniteMesure != null? (produit.uniteMesure?.replace("[","")).replace("]",""):'UM'
                                                        }}</span>
                                                </div>
                                                <div class="text-danger" v-if="validateRowProduit(produit.qteBon)">
                                                    La quantité bon est obligatoire.
                                                </div>
                                            </div>
                                        </div>
                                        <div :class="(produitIndex == 0) ? 'col-md-1 mt-4' : 'col-md-1'">
                                            <button class="btn btn-danger transition border-0 pb-2 ps-8 pe-8"
                                                type="button" @click="removeRowProduit(produitIndex)">
                                                <i class="fa fa-trash-o lh-1 me-1 position-relative top-2"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 mt-3">
                        <div class="d-flex align-items-center ">
                            <button ref="submitButton" class="btn btn-success me-3" type="submit" :disabled="isDisable">
                                Enregistrer le bon
                            </button>
                            <router-link to="/bons/liste-bonLivraison" class=" btn btn-danger ">
                                <i class="fa fa-trash-o lh-1 me-1 position-relative top-2"></i>
                            <span class="position-relative"></span>Annuler</router-link>
                        </div>
                    </div>
                </div>
            </Form>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, reactive, ref, watch } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import * as Yup from 'yup';
import ApiService from '@/services/ApiService';
import { error, format_date, success } from '@/utils/utils';
import { useRouter } from 'vue-router';
import Multiselect from '@vueform/multiselect/src/Multiselect';
import axios from 'axios';
import { max } from 'moment';

export default defineComponent({
    name: "AddMouvementFiche",
    components: {
        Form,
        Field,
        ErrorMessage,
        Multiselect
    },

    setup: () => {
        const bonSchema = Yup.object().shape({
            dateOperation: Yup.string().required('La date de l\'opération est obligatoire'),
            refDoc: Yup.string().required('La référence du document est obligatoire'),
            //typeOperation: Yup.string().required('Le type d\'opération est obligatoire'),
            //motifSuivi: Yup.string().required('Le motif de suivi est obligatoire'),
            client: Yup.string().required('Le client est obligatoire'),
        });
        const valuess = ref();
        const typeOperation = ref(null);
        const submitButton = ref<HTMLButtonElement | null>(null);
        const dateOperation = ref(getCurrentDateTime());
        const currentDateTime = ref(getCurrentDateTime());
        const refDoc = ref(null);
        const motifSuivi = ref(null);
        const produits = reactive([
            {
                produit: '',
                qteBon: 0,
                nomProd: "",
                resteAliv: 0,
                uniteMesure: null,
            },
        ]);


        watch(produits, (newValue) => {
            isDisable.value = newValue.some(produit =>
                produit.qteBon < 1 ||
                produit.uniteMesure === '' ||
                produit.produit === ''
            );
        }, { deep: true });

        const addRowProduit = () => {
            produits.push({
                produit: '',
                qteBon: 0,
                resteAliv: 0,
                uniteMesure: null,
                nomProd: ""
            },);
        };


        const removeRowProduit = (index) => {
            produits.splice(index, 1);
        };


        const selectProd = (selectedProduit, produit) => {
            produit.nomProd = selectedProduit.split("|")[1] + " - " + selectedProduit.split("|")[2];
            produit.uniteMesure = selectedProduit.split("|")[3];
            produit.qte = 0;
            produit.resteAliv = 0;
        };

        const isDis = ref(true);
        const router = useRouter();
        const produitOptions = ref([]);
        const clientOptions = ref([]);
        const motifSuiviOptions = ref([]);
        const isDisable = ref(true);

        const fetchMotifSuivi = async () => {
            try {
                const response = await ApiService.get("/all/motifSuivis");
                const invData = response.data.data.data;
                console.log(response.data.data, "invDatainvDatainvData");
                motifSuiviOptions.value = invData.map((inv) => ({
                    value: inv.id,
                    label: `${inv.libelle}`,
                }));
            } catch (error) {
                //
            }
        };

        const fetchClients = async () => {
            try {
                const response = await ApiService.get("/all/clients");
                const clientData = response.data.data;
                console.log(clientData, "clientDataclientData");
                clientOptions.value = clientData.map((client) => ({
                    value: client.id,
                    label: client.nomClient && client.prenomClient 
                ? `${client.nomClient} ${client.prenomClient}`
                : `${client.raisonSociale}`,
                }));
            } catch (error) {
                console.log(error, "errorerrorerror")
            }
        };

        const lestypes = ref([
            { value: "Entrée", label: "Entrée" },
            { value: "Sortie", label: "Sortie" }
        ]);

    function getCurrentDateTime() {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}`;
}

        const addBon = async (values, { resetForm }) => {
            if (submitButton.value) {
        // eslint-disable-next-line
        submitButton.value.disabled = true;
      }
            console.log(produits, values,"ffffffffffffff")
            if (imageFile.value) {
                console.log(imageFile.value, "imageFile.value")
                values["imagePrincipal"] = imageFile.value;
            }
            const produitcondibons = produits.map((produit) => ({
                produit: produit.produit.split("|")[0],
                qteBon: produit.qteBon,
                resteAliv: produit.resteAliv,
                uniteMesure: produit.uniteMesure,
                nomProd: produit.produit,
            }));
            values["produitcondibons"] = produitcondibons;
            try {
                await ApiService.postWithFile("/bonlivraisons", values)
                success("Le bon de livraison enregistré avec succès");
                router.push({ name: "ListeBonLivraison" });
            } catch (err) {
                submitButton.value!.disabled = false;
                error("Erreur lors de l'ajout du bon de livraison");
            }

        };


        const produit = ref();
        const getAllProduits = async () => {
            try {
                const response = await ApiService.get('/all/produitconditionnements');
                const produitsData = response.data.data;
                produitOptions.value = produitsData.map((produit) => ({
                    value: `${produit.id}|${produit.produit?.codeProduit}|${produit.produit?.nomProd}|${produit.conditionnement.libelle}`,
                    label: `${produit.produit?.codeProduit}|${produit.produit?.nomProd} [${produit.conditionnement.libelle}]`,
                }));
            }
            catch (error) {
                console.log(error, "errorerrorerror");
            }
        }

        const validateDupliacat = (e) => {
            return produits.filter((element) => element.produit === e).length > 1;
        };


        onMounted(async () => {
            fetchClients();
            fetchMotifSuivi();
            getAllProduits();
            currentDateTime.value = getCurrentDateTime();
        });

        const fileInput = ref(null);
        const imagePreview = ref(null);
        const imageFile = ref<File>(null);

        const triggerFileInput = () => {
            fileInput.value.click();
        };

        const onFilePrinChange = (event) => {
            const file = event.target.files[0];
            if (file) {
                imageFile.value = file;
                const reader = new FileReader();
                reader.onload = (e) => {
                    imagePreview.value = e.target.result;
                };
                reader.readAsDataURL(file);
            }
        };

        const removeImage = () => {
            imagePreview.value = null;
            imageFile.value = null;
        };

        const validateRowProduit = (e) => {
            return e === '' || e === 0 || e === '0' || e == null || e < 0;
        };

        return {
            typeOperation,
            clientOptions,
            selectProd,
            addBon,
            isDis,
            motifSuiviOptions,
            produitOptions,
            lestypes,
            validateDupliacat,
            isDisable,
            bonSchema,
            submitButton,
            onFilePrinChange,
            triggerFileInput,
            removeImage,
            imagePreview,
            imageFile,
            fileInput,
            produits,
            produit,
            removeRowProduit,
            addRowProduit,
            validateRowProduit,
            getAllProduits,
            dateOperation,
            motifSuivi,
            refDoc,
            currentDateTime,
            getCurrentDateTime,
            valuess
        };
    },
});
</script>


<style scoped>
.upload-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
}

.preview-card {
    width: 100%;
    height: 120px;
    border: 2px dashed #4caf50;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    overflow: hidden;
    background: #f8f8f8;
    position: relative;
}

.preview-card img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.delete-btn {
    position: absolute;
    top: 5px;
    right: 5px;
    background: red;
    color: white;
    border: none;
    padding: 5px 8px;
    border-radius: 50%;
    cursor: pointer;
    font-size: 16px;
}

.delete-btn:hover {
    background: darkred;
}
</style>